import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  linkActiveClass: "active-link",
  mode: "history",
  routes: [
    {
      path: "/home",
      name: "home",
      component: resolve => require(["@/pages/Home"], resolve)
    },
    {
      path: "/old-care",
      name: "old-care",
      component: resolve => require(["@/pages/OldCare"], resolve)
    },
    {
      path: "/join-us",
      name: "join-us",
      component: resolve => require(["@/pages/JoinUs"], resolve)
    },
    {
      path: "/tech-service",
      name: " tech-service",
      component: resolve =>
        require(["@/pages/tech-service/TechService"], resolve),
      redirect: "/tech-service/service-site",
      children: [
        {
          path: "service-site",
          name: "service-site",
          component: resolve =>
            require(["@/pages/tech-service/ServiceSite"], resolve)
        },
        {
          path: "app-show",
          name: "app-show",
          component: resolve =>
            require(["@/pages/tech-service/AppShow"], resolve)
        },
        {
          path: "after-sale-service",
          name: "after-sale-service",
          component: resolve =>
            require(["@/pages/tech-service/AfterSaleService"], resolve)
        }
      ]
    },
    {
      path: "/news-list",
      name: "news-list",
      component: resolve => require(["@/pages/news/NewsList"], resolve)
    },
    {
      path: "/news-list/news-detail",
      name: "news-detail",
      component: resolve => require(["@/pages/news/NewsDetail"], resolve)
    },
    {
      path: "/about-us-list",
      name: "about-us-list",
      component: resolve => require(["@/pages/about-us/AboutUsList"], resolve),
      redirect: "/about-us-list/company-info",
      children: [
        {
          path: "company-info",
          name: "company-info",
          component: resolve =>
            require(["@/pages/about-us/CompanyInfo"], resolve)
        },
        {
          path: "development-history",
          name: "development-history",
          component: resolve =>
            require(["@/pages/about-us/DevelopmentHistory"], resolve)
        },
        {
          path: "strategic-cooperation",
          name: "strategic-cooperation",
          component: resolve =>
            require(["@/pages/about-us/StrategicCooperation"], resolve)
        },
        {
          path: "contact-us",
          name: "contact-us",
          component: resolve => require(["@/pages/about-us/ContactUs"], resolve)
        },
        {
          path: "user",
          name: "user",
          component: resolve => require(["@/pages/about-us/user"], resolve)
        },
        {
          path: "privacy",
          name: "privacy",
          component: resolve => require(["@/pages/about-us/privacy"], resolve)
        }
      ]
    },
    {
      path: "/base-product",
      name: "base-product",
      component: resolve => require(["@/pages/about-us/baseProduct"], resolve)
    },
    {
      path: "/luxury-product",
      name: "luxury-product",
      component: resolve => require(["@/pages/about-us/luxuryProduct"], resolve)
    },
    {
      path: "/base-product",
      name: "base-product",
      component: resolve => require(["@/pages/about-us/baseProduct"], resolve)
    },
    {
      path: "/product-info",
      name: "product-info",
      component: resolve => require(["@/pages/about-us/ProductInfo"], resolve)
    },
    {
      path: "/product-info",
      name: "product-info",
      component: resolve => require(["@/pages/about-us/ProductInfo"], resolve)
    },

    {
      path: "/medical-info",
      name: "medical-info",
      component: resolve => require(["@/pages/about-us/medicalInfo"], resolve)
    },
    {
      path: "/map-site",
      name: "map-site",
      component: resolve => require(["@/pages/MapSite"], resolve)
    },
    {
      path: "/phone-download",
      name: "phone-download",
      component: resolve => require(["@/pages/PhoneDownload"], resolve)
    },
    {
      path: "/",
      name: "index",
      component: resolve => require(["@/pages/Home"], resolve)
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js